export default {
  server: 'https://api.askagirl.com',
  //server: 'http://localhost:3005',
}
